import { z } from 'zod';

export const agentCloneSchema = z.object({
  name: z.string({ message: 'Agent Name is Required' }),
  website_url: z
    .string()
    .optional()
    .refine(
      (val) => {
        if (!val) return true;
        const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
        return urlPattern.test(val);
      },
      { message: 'Invalid URL' }
    )
    .transform((val) => {
      if (!val) return val;
      if (!val.startsWith('http')) {
        return `https://${val}`;
      }
      return val;
    })
});
